import { CloseOutlined } from "@mui/icons-material";
import { Box, Grid, TextField, Typography } from "@mui/material";
import React from "react";

const RegularizationForm = ({
  regularizations,
  removeRegularization,
  setRegularizations,
}) => {
  const handleInputChange = (e, index, field) => {
    const { value } = e.target;
    const updatedRegularizations = [...regularizations];
    updatedRegularizations[index][field] = value;
    setRegularizations(updatedRegularizations);
  };
  return (
    <div>
      {regularizations.map((reg, index) => (
        <Box
          key={reg.id}
          sx={{ mb: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
        >
          <div className="flex justify-between items-center">
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#333",
                  minWidth: "30px",
                }}
              >
                {String(reg.date).padStart(2, "0")}
              </Typography>
              <Typography
                sx={{ fontSize: "14px", color: "#666", fontWeight: 600 }}
              >
                {reg.day}
              </Typography>
            </Box>
            <div>
              {!reg.isOriginal && (
                <button
                  style={{
                    background: "none",
                    border: "none",
                    color: "#999",
                    fontSize: "14px",
                    cursor: "pointer",
                    borderRadius: "4px",
                    transition: "all 0.2s",
                  }}
                  onClick={() => removeRegularization(reg.id)}
                  title="Remove regularization"
                  className="mb-3"
                >
                  <CloseOutlined />
                </button>
              )}
            </div>
          </div>

          <Grid container spacing={2}>
            {/* <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Shift</InputLabel>
                <Select value={reg.shift} label="Shift">
                  <MenuItem value="General Shift 01">General Shift 01</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#A3B2C7",
                  mb: 1,
                  fontWeight: 700,
                }}
              >
                From
              </Typography>
              <TextField
                onChange={(e) => {
                  handleInputChange(e, index, "fromTime");
                }}
                size="small"
                value={reg.fromTime}
                fullWidth
                InputProps={{ style: { fontSize: "14px" } }}
                placeholder="01:00"
              />
              <Typography sx={{ fontSize: "12px", color: "#666", mt: 0.5 }}>
                {reg.fromPeriod}
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#A3B2C7",
                  mb: 1,
                  fontWeight: 700,
                }}
              >
                To
              </Typography>
              <TextField
                onChange={(e) => {
                  handleInputChange(e, index, "toTime");
                }}
                size="small"
                value={reg.toTime}
                fullWidth
                InputProps={{ style: { fontSize: "14px" } }}
                placeholder="10:00"
              />
              <Typography sx={{ fontSize: "12px", color: "#666", mt: 0.5 }}>
                {reg.toPeriod}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#A3B2C7",
                  mb: 1,
                  fontWeight: 700,
                }}
              >
                Reason
              </Typography>
              <TextField
                onChange={(e) => {
                  handleInputChange(e, index, "reason");
                }}
                size="small"
                placeholder="Please enter a reason..."
                value={reg.reason}
                fullWidth
                InputProps={{ style: { fontSize: "14px" } }}
              />
            </Grid>
          </Grid>
        </Box>
      ))}
    </div>
  );
};

export default RegularizationForm;
